import _ from 'lodash';
import {
  addMilliseconds,
  format, isBefore,
  isWithinInterval,
  parseISO,
} from 'date-fns';

const getScheduleRunTime = (scheduleItem, asArray = false) => {
  const scheduleStart = _.get(scheduleItem, 'schedule.startedAt', '');
  const scheduleEnd = _.get(scheduleItem, 'schedule.endedAt', '');
  if (!scheduleStart) {
    return '';
  }
  if (!asArray) {
    const start = format(parseISO(scheduleStart), 'HH:mm');
    const end = format(parseISO(scheduleEnd), 'HH:mm');
    return `${start} - ${end}`;
  }
  return [scheduleStart, scheduleEnd];
};

const getAccurateRunTime = (scheduleItem, asArray = false) => {
  const [scheduleStart, scheduleEnd] = getScheduleRunTime(scheduleItem, true);
  const accurateStart = _.get(scheduleItem, 'accurateSchedule.startedAt', scheduleStart);
  const accurateEnd = _.get(scheduleItem, 'accurateSchedule.endedAt', scheduleEnd);
  if (!accurateStart) {
    return '';
  }
  if (!asArray) {
    const parsedAStart = format(parseISO(accurateStart), 'HH:mm:ss');
    const parsedAEnd = format(parseISO(accurateEnd), 'HH:mm:ss');
    return `${parsedAStart} - ${parsedAEnd}`;
  }
  return [accurateStart, accurateEnd];
};

const getShiftedScheduleTime = (scheduleItem) => {
  const [scheduleStart, scheduleEnd] = getScheduleRunTime(scheduleItem, true);
  const start = _.get(scheduleItem, 'accurateSchedule.startedAt', scheduleStart);
  const end = _.get(scheduleItem, 'accurateSchedule.endedAt', scheduleEnd);
  const startOffsetMs = _.get(scheduleItem, 'adjustment.startedAtOffsetMs', 0);
  const durationOffsetMs = _.get(scheduleItem, 'adjustment.durationOffsetMs', 0);

  let startTime = parseISO(start);
  startTime = addMilliseconds(startTime, startOffsetMs);
  startTime = format(startTime, 'HH:mm:ss');
  let endTime = parseISO(end);
  endTime = addMilliseconds(endTime, startOffsetMs);
  endTime = addMilliseconds(endTime, durationOffsetMs);
  endTime = format(endTime, 'HH:mm:ss');

  return `${startTime} - ${endTime}`;
};

const isProgramLive = (scheduleItem) => {
  const now = new Date();
  const [scheduleStart, scheduleEnd] = getScheduleRunTime(scheduleItem, true);
  return isWithinInterval(now, { start: parseISO(scheduleStart), end: parseISO(scheduleEnd) });
};

const isProgramRewatchable = (scheduleItem) => {
  if (isProgramLive(scheduleItem)) {
    return false;
  }
  const now = new Date();
  const [scheduleStart] = getScheduleRunTime(scheduleItem, true);
  return isBefore(parseISO(scheduleStart), now);
};

export {
  getScheduleRunTime,
  getAccurateRunTime,
  getShiftedScheduleTime,
  isProgramLive,
  isProgramRewatchable,
};
